export default {
    ARIATemplate: String, 
    culture: String, 
    dates: Array, 
    depth: String, 
    disableDates: Array | Function, 
    footer: String | Function, 
    format: String, 
    max: Date, 
    messages: Object, 
    min: Date, 
    month: Object, 
    labels: Boolean, 
    weekNumber: Boolean, 
    range: Object, 
    start: String, 

    // Events
    change: Function, 
    close: Function, 
    open: Function
}


// WEBPACK FOOTER //
// ./packages/kendo-dateinputs-vue-wrapper/src/KendoDateRangePicker/DateRangePickerProps.js